export const locale = {
    lang: 'es',
    data: {
        "Acc_Lbl_BasicInformation": "Información básica",
        "Acc_Lbl_FirstName": "Nombre",
        "Acc_Lbl_LastName": "Apellido",
        "Acc_Val_FirstNameReq": "Se requiere nombre.",
        "Acc_Val_LastNameReq": "Se requiere apellido.",
        "Acc_Val_Email": "El correo electrónico debe ser una dirección de correo electrónico válida.",
        "Acc_Placeholder_Email": "tú@sudominio.com",
        "Acc_Placeholder_Name": "p. ej..",
        "Acc_Lbl_Work Email": "Correo electrónico de trabajo",
        "Acc_Head_Ph.No": "Números de teléfono",
        "Acc_War_Ph.No": "No tienes números de teléfono afiliados a esta cuenta. Por favor, considere la posibilidad de agregar uno.",
        "Acc_Val_Ph.No": "El teléfono debe ser un número de teléfono válido.",
        "Acc_War_NotVerified": "No verificado",
        "Acc_War_Verified": "Verificado",
        "Acc_War_InProgress": "En curso",
        "Acc_Btn_VeriyByText": "Verificar por texto",
        "Acc_Btn_VeriyByCall": "Verificar por llamada",
        "Acc_War_StopRecieved" : "Dejar de recibir",
        "Acc_Hover_NotVerified": "No verificado: Debe verificar su número ya sea por mensaje de texto o llamada antes de que este número se pueda usar para recibir notificaciones.",
        "Acc_Btn_AddPh.No": "Agregar número de teléfono",
        "Mobile": "Móvil",
        "Work": "Trabajo",
        "Home": "Hogar",
        "Acc_Error_Verification": "Se ha producido un problema al recuperar la configuración de su cuenta.",
        "Acc_Not_Ph.NoSMS": "Una solicitud para verificar su número de teléfono se envió como un mensaje de texto.",
        "Acc_Not_Ph.NoCall": "ASe envió una solicitud para verificar su número de teléfono como una llamada telefónica.",
        "Acc_Error_Ph.NoSMS": "No se puede iniciar el mensaje de texto de verificación.",
        "Acc_Error_Ph.NoCall": "No se puede iniciar la llamada telefónica de verificación.",
        "Acc_Success_Ph.No": "Solicitud de verificación enviada",
        "Acc_Verification_InProgress": "En curso: la verificación se ha enviado por llamada telefónica o mensaje de texto y el sistema está esperando la respuesta.",
        "Acc_Verification_Verified": "Verificado: Ahora puede habilitar los mensajes de texto y recibir notificaciones sobre este número.",
        "Acc_STOPMessage": "Stop Received: el destinatario de la notificación ha respondido con un mensaje STOP; por lo tanto, el teléfono permanece sin verificar.",
        "Acc_Verification_NotVerified": "No verificado: Debe verificar su número ya sea por mensaje de texto o llamada antes de que este número se pueda usar para recibir notificaciones.",
        "Acc_Success_Message": "Se guardó la configuración de su cuenta.",
        "Acc_Error_Save" : "Hubo un problema al guardar la configuración de su cuenta.",
        "Acc_Language":"Idioma",
        "Secure_MFA_Header": "Autenticación Multifactor (MFA)",
        "Secure_MFA_Description": "MFA evita el acceso no autorizado a su cuenta al solicitarle que ingrese un código de verificación cuando se le solicite",
        "Secure_MFA_Enable": "MFA Habilitado",
        "Secure_MFA_Disable": "MFA Deshabilitado",
        "Secure_Choose_MFA_Method": "Elija su método preferido de MFA:",
        "Secure_Authentication_App_Lbl": "Aplicación de autenticación (Más segura, Recomendada)",
        "Secure_Phn_Verification_lbl": "Verificación por teléfono",
        "Secure_Email_Verification_lbl": "Verificacion de email",
        "Secure_Single_Sign_lbl": "Inicio de sesión único",
        "Secure_Enable_Single_Sign_lbl": "Puede habilitar el inicio de sesión único con la cuenta de su empresa.",
        "Secure_lbl_Enable": "Habilitar",
        "Secure_Single_Sign_Enabled_lbl": "Se ha habilitado el inicio de sesión único para esta cuenta con la siguiente dirección de correo electrónico:",
        "Secure_lbl_Disable": "Desactivar",
        "Secure_Single_Sign_Error_lbl": "Hubo un error durante su solicitud de inicio de sesión único. Vuelva a intentarlo o comuníquese con el administrador de su empresa.",
        "Secure_Automatic_Signout_Header": "Cierre de sesión automático",
        "Secure_Automatic_Signout_Description": "Cerrar sesión automáticamente cuando he estado inactiva por:",
        "Secure_Hour_lbl": "Hora",
        "Secure_Minute_lbl": "Minuto",
        "Secure_Timedout_Description": "Paycor recomienda un cierre de sesión automático de 20 minutos; esta configuración no se aplica a Paycor Payroll. Esta configuración entrará en vigor la próxima vez que inicie sesión.",

        "Action_Lbl_MyAction": "Mis acciones",
        "Action_Not_SSOProvider": "Sus credenciales se administran a través de su proveedor de inicio de sesión único (SSO).",
        "Action_Lnk_ChangePass": "Cambia tu contraseña",
        "Action_Lnk_ChangeQue": "Cambie sus preguntas de seguridad",
        "Action_Lnk_ChangeUsername": "Cambiar otros nombres de usuario para una experiencia de inicio de sesión único",
        "Action_Lnk_DeveloperPortal": "Go Back",
        "Notification_Setting_Display_Message":"Seleccione cómo le gustaría recibir cada notificación individual.",
        "Notification_Text":"Notificaciones",
        "Block_MySettings":"This page is not supported during Impersonation.",
        "Google_Auth_QR_Description1": "Visite la tienda de aplicaciones de su dispositivo móvil, busque \"autenticador\" y descargue una aplicación de su elección. (Google Authenticator, Microsoft Authenticator y Authy son populares y fáciles de usar)",
        "Google_Auth_QR_Description2": "Utilice la aplicación para escanear este código QR, que sincronizará los códigos que proporciona con su cuenta Perform:",
        "Google_Auth_QR_Scan_Trouble_Linklbl": "¿Tiene problemas para escanear?",
        "Google_Auth_Code_Description": "¿Tiene problemas para escanear el código de barras? Puede ingresar esta clave junto con su correo electrónico en su aplicación de autenticación en su dispositivo.",
        "Google_Auth_Code_Step1": "Ingrese su correo electrónico y el siguiente código en su aplicación de autenticación.",
        "Google_Auth_Code_Step2": "Presione continuar y confirme el código de 6 dígitos generado desde su dispositivo.",
        "Google_Auth_QR_Scan_Linklbl": "Intente escanear el código QR nuevamente",
        "Google_Auth_Verify_Code_Description1": "Recibirá un código de 6 dígitos cuando su cuenta se haya vinculado correctamente. Ingrese ese código a continuación para completar la configuración de la autenticación de Google.",
        "Google_Auth_Verify_Code_Description2": "La próxima vez que inicie sesión, se le pedirá un código.",
        "Google_Auth_Verify_Code_lbl": "Código de autenticador de 6 dígitos",
        "Google_Auth_Verify_Code_Placeholder": "Introduzca el código",
        "Google_Auth_Invalid_Code_Error": "Código de autenticación no válido",
        "Google_Auth_Setup_Header": "Configurar Autenticador",
        "Google_Auth_QR_Retrieve_Error_Msg": "Se produjo un error al recuperar el código QR.",
        "Google_Auth_Code_Validating_Error_Msg": "Hubo un error al validar el código.",
        "Google_Auth_Code_Validating_Header": "Confirmar el código de autenticador",

        "Secure_MFA_Atleast_Two_Options_Select_Error": "Deben seleccionarse al menos dos opciones de MFA",
        "Secure_MFA_Data_Retrieving_Error": "Hubo un problema al recuperar la configuración de seguridad de mfa.",
        "Secure_MFA_Data_Saved_Msg": "Se guardó su configuración de MFA.",
        "Secure_MFA_Data_Save_Error_Msg": "Hubo un problema al guardar la configuración de MFA.",
        "Secure_SecureSetting_Data_Retrieving_Error": "Hubo un problema al recuperar la configuración de seguridad.",
        "Secure_SecureSetting_Data_Saved_Msg": "Tu configuración de seguridad se guardó.",
        "Secure_SecureSetting_Data_Save_Error_Msg": "Hubo un problema al guardar la configuración de seguridad.",
        "Notification_TextSMS":"Texto(SMS)",
        "Notification_MobileApp":"Aplicación movil",
        "Notification_Inapp":"En la aplicación",
        "Notification_Email":"Correo electrónico",
        "Notification_Save_Message":"Se guardaron las preferencias de notificación.",
        "Notification_Success":"¡Éxito!",
        "Notification_Error_Message":"Hubo un problema al guardar tus preferencias de notificación.",
        "Notification_Error":"¡Error!",


        // common  key value pairs that can be used in all pages can add inside this
        "Common": {
            "Save": "Guardar",
            "Cancel": "Cancelar",
            "Error": "Ocurrió un error",
            "PleaseWait": "Espera…",
            "ErrorSummary": "¡Error!",
            "Success": "Éxito",
            "Continue": "Continuar",
            "Verify": "Verificar",
        },
        //End
        // title key value pair can be added
        "Title": {
            "MySettings": "Mi configuración",
            "Account": "Cuenta",
            "Security": "Seguridad",
            "Notification_Preferences":"Preferencias de notificación"
        }
        //End
    }
};


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/my-settings/shared/assets/i18n/es.ts